import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import socketio from 'socket.io-client';
import Echo from 'laravel-echo';
import notificationsActions from '../store/actions/notificationsActions';
import orderActions from '../store/actions/order.actions';
import ORDERS from '../constants/ordersConstant';
import messageActions from '../store/actions/messageActions';
import productActions from '../store/actions/productActions';

export const SOCKET_NOTIFICATIONS = 'notifications';
export const SOCKET_ORDER = 'order';
export const SOCKET_PRODUCT = 'product';

const useSocket = (channelType) => {
  const [result, setResult] = useState(null);
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token && window && !window.echo) {
      const host = process.env.SOCKET_GATE;
      const path = `${process.env.PATH_PREFIX || ''}/socket.io`;
      if (!window.io) window.io = socketio;
      window.echo = new Echo({
        host,
        path,
        broadcaster: 'socket.io',
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      });
    } else if (window && window.echo && user && user.id && channelType) {
      switch (channelType) {
        case SOCKET_NOTIFICATIONS:
          window.echo.private(`notification.${user.id}`)
            .listen('.notification', (e) => {
              setResult(e);
              dispatch(notificationsActions.addUnreadNotifications(e));
            });
          break;
        case SOCKET_ORDER:
          window.echo.private(`order.${user.id}`)
            .listen('.order.message', (e) => {
              setResult(e);
              dispatch(orderActions.addNewChatMessages(e));
            })
            .listen('.order.created', (e) => {
              setResult(e);
              dispatch(orderActions.changeOrderStatus(ORDERS.STATUS_OPEN, e, user.id));
            })
            .listen('.order.confirm', (e) => {
              setResult(e);
              dispatch(orderActions.changeOrderStatus(ORDERS.STATUS_DONE, e, user.id));
            })
            .listen('.order.track-number', (e) => {
              setResult(e);
              dispatch(orderActions.changeOrderStatus('', e, user.id));
            })
            .listen('.order.completed', (e) => {
              setResult(e);
              dispatch(orderActions.changeOrderStatus(ORDERS.STATUS_DONE, e, user.id));
            })
            .listen('.order.cancel', (e) => {
              setResult(e);
              dispatch(orderActions.changeOrderStatus(ORDERS.STATUS_CANCEL, e, user.id));
            });
          break;
        case SOCKET_PRODUCT:
          window.echo.private(`product.${user.id}`)
            .listen('.product.message', (e) => {
              setResult(e);
              dispatch(messageActions.addNewChatMessages(e));
            })
            .listen('.product.event', (e) => {
              setResult(e);
              dispatch(productActions.changeProductInfo(e));
            });
          break;
        default:
          break;
      }
    }

    return () => {
      if (window && window.echo && user && user.id && channelType) {
        switch (channelType) {
          case SOCKET_NOTIFICATIONS:
            window.echo.leave(`notification.${user.id}`);
            break;
          case SOCKET_ORDER:
            window.echo.leave(`order.${user.id}`);
            break;
          case SOCKET_PRODUCT:
            window.echo.leave(`product.${user.id}`);
            break;
          default:
            break;
        }
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user, channelType]);

  return result;
};

export default useSocket;
